import { Component, OnInit, AfterViewInit, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, RouterEvent, ActivatedRoute, Params } from '@angular/router'
import { AccessControlService } from './services/access-control.service';
import { Subject } from 'rxjs';
import { SharedService } from './shared-service/shared.service';
// declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Expentor-GSF';
  showPreference=false;
  constructor(
    private accessControlService: AccessControlService,
    private router: Router,private currentRoute:ActivatedRoute,private sharedService:SharedService,private changeDectorRef:ChangeDetectorRef
  ) {
    if(localStorage.getItem('token')){
      this.showPreference=true;
    }
   }
  ngOnInit() {

      this.sharedService.tokenExpiredEvent.subscribe((res:string)=>{
        if(res=='changed')
        this.showPreference=false;
        else
         this.showPreference=true;
         this.changeDectorRef.detectChanges();
      });
      if(document.getElementById("lds-roller'"))
      document.getElementById("lds-roller'").style.display="none";
  }
  ngAfterViewInit() {

  }



}
